var map = {
	"./icon_clap_down_dark.png": 306,
	"./icon_clap_down_white.png": 307
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 737;


//////////////////
// WEBPACK FOOTER
// ./src/modules/knowledge/components/images ^\.\/icon_clap_down_.*\.png$
// module id = 737
// module chunks = 0